import { useState, useMemo } from "react";
import { SearchInput } from "../atoms/SearchInput";
import { FilterButton } from "../atoms/FilterButton";
import { PageHeader } from "../molecules/PageHeader";
import { SectionHeader } from "../molecules/SectionHeader";
import { ExportButton } from "../molecules/ExportButton";
import { ReportedItemCard } from "../molecules/ReportedItemCard";
import { StatsGrid } from "../organisms/StatsGrid";
import { DataTable } from "../organisms/DataTable";
import { Filter, More } from "iconsax-react";

import {
  USER_STATS,
  MOCK_USERS,
  MOCK_REPORTED_USERS,
  USER_TABLE_HEADERS,
  type User,
} from "@/data";

const DefaultFilterButton = () => (
  <button className="bg-white flex items-center text-sm gap-1 px-1.5 py-1 rounded-[5px] text-black hover:border-dark-60 transition-colors">
    <Filter color="#000" size={14} />
    Filter
  </button>
);

const UserTableRow = ({ user }: { user: User }) => (
  <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
    <td className="px-6 py-4 text-dark-text font-medium">{user.name}</td>
    <td className="px-6 py-4 text-dark-text">{user.email}</td>
    <td className="px-6 py-4 text-dark-text">{user.age}</td>
    <td className="px-6 py-4 text-dark-text">{user.gender}</td>
    <td className="px-6 py-4 text-dark-text">{user.location}</td>
    <td className="px-6 py-4 text-dark-text">{user.joined}</td>
    <td className="px-6 py-4 text-dark-text">{user.status}</td>
    <td className="px-6 py-4 text-dark-text">{user.lastActive}</td>
    <td className="px-6 py-4">
      <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
        <More className="w-6 h-6" color="#EEEEEE" />
      </button>
    </td>
  </tr>
);

const UserManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Filter users based on search term
  const filteredUsers = useMemo(() => {
    if (!searchTerm) return MOCK_USERS;
    return MOCK_USERS.filter((user) =>
      user.id.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  return (
    <div className="max-w-7xl mx-auto space-y-10">
      <PageHeader title="User Management" />

      <StatsGrid stats={USER_STATS} columns={3} />

      <DataTable
        title="User Table"
        headers={USER_TABLE_HEADERS}
        data={filteredUsers}
        renderRow={(user) => <UserTableRow key={user.id} user={user} />}
        filters={
          <>
            <DefaultFilterButton />
            <FilterButton label="Status" />
            <FilterButton label="Date Joined" />
            <SearchInput value={searchTerm} onChange={setSearchTerm} />
          </>
        }
        actions={<ExportButton label="Export as CSV" />}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />

      <section>
        <SectionHeader title="Reported Users" />
        <div className="space-y-2">
          {MOCK_REPORTED_USERS.map((user, index) => (
            <ReportedItemCard
              key={index}
              name={user.name}
              reports={user.reports}
              lastReported={user.lastReported}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default UserManagement;
